/**
 * Tabbed Image with Text Component
 * @module patterns/components/tabbed-image-with-text
 */

import { App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Tabbed Image with Text Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountTabbedImageWithText(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Tabbed Image with Text component', error);
        });

    return function destroyTabbedImageWithText() {
        unmountTabbedImageWithText(listeners);

        app.logger.debug('[DXA] Tabbed Image with Text component destroyed');
    };
};

// Extracted method for logic reuse within other component
export function mountTabbedImageWithText(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;

    const tabbedImageWithTexts = rootNode.querySelectorAll<HTMLElement>('.tabbed-image-with-text');
    for (const tabbedImageWithText of tabbedImageWithTexts) {

        const tabClicks = tabbedImageWithText.querySelectorAll<HTMLElement>('.nav-link')

        tabClicks.forEach((tab, index) => {
            const handleTabClick = () => {
                const contentTabs = tabbedImageWithText.querySelectorAll<HTMLElement>(`#nav-tabContent .tab-pane`);
                const activeContentTab = tabbedImageWithText.querySelector<HTMLElement>(`#nav-${index}-content`);

                for (const contentTab of contentTabs){
                    contentTab.classList.remove('show', 'active');
                }
                activeContentTab?.classList.add('show', 'active')

            }

            tab.addEventListener("show.bs.tab", handleTabClick);
            listeners.push([tab, "show.bs.tab", handleTabClick]);
        });
    }
}

export function unmountTabbedImageWithText(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
